import axios from 'axios'
import { onSuccess, onError, beforeRequestSuccess, beforeRequestError } from './interceptors'

const competitorClient = axios.create({
  baseURL: process.env.COMPETITOR_API,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8'
  }
})

competitorClient.interceptors.request.use(beforeRequestSuccess, beforeRequestError)

competitorClient.interceptors.response.use(onSuccess, onError)

export let client = competitorClient



// WEBPACK FOOTER //
// ./src/api/competitor/client.js